export default {"src":"https://fishbrain.com/_next/static/media/water.f4ad4c08.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};